import IconArrowLineRight from 'assets/Icons/Arrow/Icon_arrowLine_right';
import styled from 'styled-components';
import { BackgroundColor, BorderColor, PrimaryColor } from 'styles/Global/colorSemantic';
import { Radius } from 'styles/Global/objectStyles';
import { Body3Bold, Body5Regular } from 'styles/Global/typography';

import AiRobot from 'assets/Icons/Ai/AiRobot';

export default function AIResultButton({ onClick }: { onClick: () => void }) {
    return (
        <ButtonContainer onClick={onClick}>
            <ContentContainer>
                <AiRobot />
                <TextContentContainer>
                    <Body3Bold>AI 종합 분석</Body3Bold>
                    <Body5Regular>우리 아이 맞춤으로 분석했어요!</Body5Regular>
                </TextContentContainer>
            </ContentContainer>
            <ArrowContainer>
                <IconArrowLineRight color={PrimaryColor.color_primary_normal} />
            </ArrowContainer>
        </ButtonContainer>
    );
}

const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px 16px 16px;
    border-radius: ${Radius.radius_8};
    background-color: #fff;
    border: 1px solid ${BorderColor.color_border_weak};
    gap: 4px;
`;

const ContentContainer = styled.div`
    display: flex;
    gap: 12px;
    align-items: center;
`;

const TextContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

const ArrowContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 6px;
    border-radius: 12px;
    background-color: ${BackgroundColor.color_background_primary_normal};
`;
